import reduxStore from 'redux/store'
import {setConfirmNotifications} from "../redux/actions";

export const simpleConfirm = (confirmText, onConfirm, onCancel) =>
    confirmComplex({confirmText, onConfirm, onCancel})

export const simpleConfirmNoTranslate = (confirmText, onConfirm, onCancel) =>
    confirmComplex({confirmText, onConfirm, onCancel, translateConfirmTexts: false})

export const confirmComplex = ({onConfirm, onCancel, confirmText, confirmText2, labelConfirm, labelCancel, translateConfirmTexts}) => {
    reduxStore.dispatch(setConfirmNotifications({
        confirmText,
        confirmText2,
        onConfirm,
        onCancel,
        labelConfirm,
        labelCancel,
        translateConfirmTexts
    }))
}

